module.exports = __webpack_public_path__ + "img/createBookshelf.74ae58ae.svg";